import { render } from "./Reset.vue?vue&type=template&id=fc1d24ac&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=fc1d24ac&scoped=true&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc1d24ac"]])

export default __exports__